module.exports = __webpack_public_path__ + "static/kartchen6-dfcb25d3c21b205d7aec58bb2cb79370.png";